var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLiveTest = function SvgIconLiveTest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-live-test_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79 0 0 1.79 0 4v16c0 2.21 1.79 4 4 4h16c2.21 0 4-1.79 4-4V4c0-2.21-1.79-4-4-4Zm-9.36 14.87L7.4 18.11c-.2.2-.45.29-.71.29-.26 0-.51-.1-.71-.29l-1.94-1.94a.996.996 0 1 1 1.41-1.41l1.23 1.23 2.53-2.53a.996.996 0 1 1 1.41 1.41h.02Zm0-7.56L7.4 10.55c-.2.2-.45.29-.71.29-.26 0-.51-.1-.71-.29L4.04 8.61A.996.996 0 1 1 5.45 7.2l1.23 1.23L9.21 5.9a.996.996 0 1 1 1.41 1.41h.02Zm8.61 9.47h-5.57c-.55 0-1-.45-1-1s.45-1 1-1h5.57c.55 0 1 .45 1 1s-.45 1-1 1Zm0-7.56h-5.57c-.55 0-1-.45-1-1s.45-1 1-1h5.57c.55 0 1 .45 1 1s-.45 1-1 1Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-live-test_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconLiveTest;